import { AnyAction } from 'redux'

import { AnalyticsHandlers } from '~/lib/analytics/handlers/types'

export const NAMESPACE = '@@analytics'

const MIN = -2147483648
const MAX = 2147483647

export function validateProperties(properties: any) {
    for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
            const raw = properties[key]

            if (isNaN(raw)) {
                continue
            }

            const value = parseInt(raw, 10)

            // if it is a float continue
            if (Number(value) !== raw) {
                continue
            }

            // test between min integer and max integer
            if (value < MIN || value > MAX) {
                throw new Error(
                    'Analytics payload contains integer values that are out of range.',
                )
            }
        }
    }
}

export default function instrumentAction<T extends keyof AnalyticsHandlers>(
    action: AnyAction,
    type: T,
    payload: Parameters<AnalyticsHandlers[T]>[0],
) {
    if (!(type && payload)) {
        throw new Error('Analytics event missing type or payload')
    }

    // validate the payload is within int range ... analytics endpoint does deep validation 1 level will do here.
    if ('properties' in payload) {
        validateProperties(payload.properties)
    }

    return {
        ...action,
        meta: {
            ...action.meta,
            [NAMESPACE]: {
                type,
                payload,
            },
        },
    }
}
